var _defs, _rect, _path, _polygon, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiltersFormat4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffdbb1;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #abceff;\n      }\n\n      .cls-4 {\n        fill: #2e85ff;\n      }\n\n      .cls-5 {\n        fill: #82b6ff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22,
    y: 7,
    width: 6,
    height: 6,
    rx: 0.74,
    ry: 0.74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m29,10.85h-11.76l-.56-1.91c-.34-1.15-1.43-1.95-2.67-1.95H2.79c-1.54,0-2.79,1.21-2.79,2.7v19.45c0,2.13,1.79,3.85,4,3.85h25c2.21,0,4-1.72,4-3.85v-14.44c0-2.13-1.79-3.85-4-3.85Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14 20 14 16 10 16 10 20 6 20 6 24 10 24 10 28 14 28 14 24 18 24 18 20 14 20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 19,
    y: 31,
    width: 4,
    height: 4,
    rx: 0.74,
    ry: 0.74
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28,
    y: 20,
    width: 8,
    height: 8,
    rx: 1.14,
    ry: 1.14
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 36,
    y: 14,
    width: 4,
    height: 4,
    rx: 0.74,
    ry: 0.74
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersFormat4);
export default __webpack_public_path__ + "static/media/filters_format4.3eb67ecbb5e1f7c1b7f33456e132fe04.svg";
export { ForwardRef as ReactComponent };